export default __webpack_public_path__ + "static/castrightplain-2d35126d3fd2d695117dbbcf13a77229.svg";